import { jsx as _jsx } from "react/jsx-runtime";
import { CatTextLink } from '@blocks-react/components/TextLink';
import styles from '../NotificationDrawer.module.scss';
export const ClearFilter = ({ title, handleClearFilter, tabIndex }) => {
    return (_jsx(CatTextLink, { size: "xs", className: `${styles['notification_drawer-clear-filter']}`, onClick: handleClearFilter, onKeyDown: handleClearFilter, "data-testid": "clear-filter-button", tabIndex: tabIndex, children: title }));
};
